import { render } from "./StatsContainerPopover.vue?vue&type=template&id=83f4aee2&scoped=true"
import script from "./StatsContainerPopover.vue?vue&type=script&lang=js"
export * from "./StatsContainerPopover.vue?vue&type=script&lang=js"

import "./StatsContainerPopover.vue?vue&type=style&index=0&id=83f4aee2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f4aee2"]])

export default __exports__